// @flow
import React, { Component } from "react";
import GoogleMapsLoader from "google-maps";
import Spinner from "@atlaskit/spinner";
import serverdateFormat from "dateformat";
import dateFormat from "../utils/localdateformat";
import { isCD } from "../rest/utils/envDetection";
import { decode } from "../utils/string";

import { MapOuter, Map, Outer, SpinnerContainer, Stops, Stop, StopDate, Location } from "./styled";

type Props = {|
    userInfo: Object,
    stops: Object,
    onFetchStops: Function
|};

type State = {|
    isLoading: boolean,
    displayed: boolean,
    google: Object,
    map: Object
|};

class MapView extends Component<Props, State> {
    constructor(props) {
        super(props);
        const { stops } = props;
        this.state = {
            isLoading: stops === null
        };
    }
    componentDidMount() {
        if (isCD) {
            console.log("Not Loading GoogleMaps on CD");
            return;
        }

        console.log("Loading GoogleMaps");
        GoogleMapsLoader.KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
        GoogleMapsLoader.VERSION = "weekly";
        GoogleMapsLoader.load(google => {
            console.log("Loaded GoogleMaps");
            this.setState({ google });
        });

        if (this.props.stops === null) {
            this.props.onFetchStops();
        }
    }

    componentDidUpdate() {
        if (this.state.google !== null && this.props.stops !== null && !this.state.displayed) {
            const stops = this.props.stops.slice().reverse();
            this.drawMap(stops);
        }
    }

    drawMap(stops) {
        const { google } = this.state;
        const { userInfo } = this.props;

        if (google === undefined) {
            console.log("Googlemaps unavailable");
            return;
        }

        this.setState({ displayed: true });
        const user = userInfo[0];
        const today = serverdateFormat(new Date(), "yyyy-mm-dd");

        const iconImg = new google.maps.MarkerImage(
            "/gdot-5.gif",
            new google.maps.Size(9, 9),
            new google.maps.Point(0, 0),
            new google.maps.Point(5, 4)
        );

        const map = new google.maps.Map(document.getElementById("map"), {
            zoom: 3,
            backgroundColor: "#fff", // for example
            center: { lat: 50, lng: 0 }
        });

        const pathStops = [];
        let lastStop = null;
        let isFuture = false;
        stops.forEach(thisStop => {
            const stop = { ...thisStop, drawLine: thisStop.drawLine && user.mapLines };
            if (stop.date > today && lastStop.date <= today) {
                this.drawPath(map, pathStops);
            }

            isFuture = stop.date > today;
            if (stop.drawLine) {
                if (lastStop != null && !lastStop.drawLine) {
                    pathStops.push(lastStop);
                }
                pathStops.push(stop);
            } else {
                this.drawPath(map, pathStops, isFuture);
            }

            if (!stop.drawLine && !isFuture) {
                this.drawStop(map, stop, iconImg);

                if (lastStop !== null && lastStop.drawLine) {
                    this.drawStop(map, lastStop, iconImg, isFuture);
                }
            }

            lastStop = stop;
        });
        this.drawPath(map, pathStops, isFuture);

        if (user.location !== null && user.location !== undefined) {
            const marker = new google.maps.Marker({
                position: {
                    lat: 90 - user.location.ypos,
                    lng: user.location.xpos - 180
                },
                icon: {
                    path: google.maps.SymbolPath.CIRCLE,
                    scale: 15,
                    fillColor: "#7C1807",
                    fillOpacity: 0.3,
                    strokeOpacity: 0
                }
            });
            marker.setMap(map);
            map.setCenter({
                lat: 90 - user.location.ypos,
                lng: user.location.xpos - 180
            });
        }
    }

    drawPath(map, pathStops, isFuture) {
        if (pathStops.length > 0) {
            const { google } = this.state;
            const path = new google.maps.Polyline({
                path: pathStops,
                geodesic: false,
                strokeColor: "#7C1807",
                strokeOpacity: isFuture ? 0.2 : 1.0,
                strokeWeight: 3
            });

            path.setMap(map);
            pathStops.length = 0; // eslint-disable-line no-param-reassign
        }
    }

    drawStop(map, stop, icon) {
        const { google } = this.state;
        const marker = new google.maps.Marker({
            position: stop,
            icon
        });
        marker.setMap(map);
    }

    render() {
        const { stops } = this.props;
        return isCD ? (
            <img alt="map" src="./DCIM/100JEALO/map.png" width="100%" />
        ) : (
            <div>
                {this.state.isLoading && (
                    <SpinnerContainer>
                        <Spinner
                            size="medium"
                            isCompleting={this.props.stops != null}
                            onComplete={() => this.setState({ isLoading: false })}
                        />
                    </SpinnerContainer>
                )}
                <MapOuter>
                    <Map id="map" style={{ display: this.state.isLoading ? "none" : null }} />
                </MapOuter>

                {stops && (
                    <Outer>
                        <Stops>
                            {stops.map(stop => (
                                <Stop key={stop.id}>
                                    <StopDate>{dateFormat(stop.date, "mmm dS yyyy")}</StopDate>
                                    <Location>
                                        {decode(stop.location)}, {decode(stop.country)}
                                    </Location>
                                </Stop>
                            ))}
                        </Stops>
                    </Outer>
                )}
            </div>
        );
    }
}

export default MapView;



// WEBPACK FOOTER //
// ./src/map/view.js